import { isEmpty } from 'lodash';
import { store } from 'redux/store';
import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
export async function UpdateCompany(companyId, inputs) {
    const user = store?.getState()?.user
    let path = null,
        method = 'POST';

    if (isAuthenticated() && user) {
        let formData = new FormData();
        for (const property in inputs) {
            formData.append(property, inputs[property]);
        }
        if (window.SPONSOR_AUTH) {
            path = `${process.env.REACT_APP_MYXP_API_V2}/sponsor/company-profile`;
            method = 'PUT';
        } else
            path = `${process.env.REACT_APP_MYXP_API_VIRTUAL}/v1/manager/company-profiles/${companyId}`;

        const response = await apiInterceptor(path, {
            method,
            headers: {
            },
            body: formData,
        });

        return await response.json();
    }
}
